"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloorplanPreferredAmenity = void 0;
var FloorplanPreferredAmenity = /** @class */ (function () {
    function FloorplanPreferredAmenity() {
        this.parentId = 0;
        this.id = 0;
        this.name = '';
    }
    return FloorplanPreferredAmenity;
}());
exports.FloorplanPreferredAmenity = FloorplanPreferredAmenity;
